const Backbone = require('backbone');
const $ = (Backbone.$ = window.jQuery);
const parameters = require('./data/parameters.js');

// locale FR
require('moment');
require('moment/locale/fr');

if (parameters.get('api_authorization_header')) {
  $.ajaxSetup({
    headers: { Authorization: `Bearer ${parameters.get('api_authorization_header')}` }
  });
}

// initialize application
const app = require('./app.js');

// configure commands
app.router.route('*actions', () => {
  app.execute('error', '404: Not found');
});

app.commands.setHandler('error', error => {
  app.rootView.destroy();

  throw error.toString();
});

app.commands.setHandler('show:club', require('./commands/goto-planning.js'));
app.commands.setHandler('show:coach', require('./commands/goto-coach.js'));

$(() => {
  app.rootView.setElement($('#app_container'));

  // boot application
  app.start();
});



// WEBPACK FOOTER //
// ./src/index.js